export const localizedMapSlugs: Record<string, string> = {
  en: "map",
  ro: "harta",
  de: "karte",
  es: "mapa",
  fr: "carte",
  it: "mappa",
  nl: "kaart",
  pt: "mapa",
  pl: "mapa",
  da: "kort",
  sv: "karta",
  fi: "kartta",
  no: "kart",
  cs: "mapa",
  sk: "mapa",
  hu: "terkep",
  hr: "karta",
  sl: "zemljevid",
  sr: "mapa",
  bg: "karta",
  ru: "karta",
  uk: "karta",
  el: "chartis",
  tr: "harita",
  ja: "chizu",
  ko: "jido",
  zh: "ditu",
  ar: "kharita",
  hi: "naksha",
  // Add/adjust based on your exact routing locales
};

/**
 * Returns the localized word for "map" based on the locale.
 */
export function getLocalizedMapSlug(locale: string): string {
  return localizedMapSlugs[locale] || "map";
}

/**
 * Checks if a given URL segment is any of the localized variations of "map".
 */
export function isMapSlug(slug: string): boolean {
  const normalizedSlug = slug.toLowerCase();
  return Object.values(localizedMapSlugs).includes(normalizedSlug);
}
